<bis-navbar id="navbar-defaut" class="fixed-top" [title]="getTitreCompletRaccourci$() | async"></bis-navbar>
<!-- bandeau pour l’impression -->
<div class="row ml-2" *ngIf="(modeRenduService.enModeImpression$ | async)">
  <div id="logo" class="pl-0 pr-0">
    <img
          class="pr-2 pt-2" style="float: left;" alt="Ministère de la Justice" src="./assets/img/logoRp.png" height=100 />
    <img class="pr-2" style="float: left;" alt="SSM du Ministère de la Justice"
      src="./assets/img/logoSser.svg" height=100 />
  </div>
  <div class="my-auto">
    <span class="titre">Ministère de la Justice<br />Secrétariat Général<br />SSER</span>
  </div>
</div>
<div [ngClass]="{container: true}">
  <main class="mx-md-3 pt-2">
    <h1>{{ getTitreComplet$() | async }} <mat-spinner [hidden]="(spinner.hidden$ | async)" diameter=32 style="
      display: inline;
      position: absolute;
      margin-top: 0.2em;
      margin-left: 0.5em"></mat-spinner></h1>
    <div *ngIf="AUTH.isUtilisateurAuthentifie()">
      <h5 class="mt-2">Date Limite : <i>{{ getDateFinEnquete$() | async }}</i></h5>
    </div>
    <div *ngIf="!AUTH.isUtilisateurAuthentifie()">
      <button *ngIf="!isLog" type="button" (click)="initializeSession()">init session</button>
    </div>
    <!-- Spinner affiché quand des requêtes HTTP sont en cours-->
    <!--
            <div class="spinner" [hidden]="(spinner.hidden$ | async)">
              <mat-spinner></mat-spinner>
            </div>-->
    <!-- Affichage du contenu des différentes "routes" (eg : saisie, authentification) -->
    <router-outlet></router-outlet>
  </main>
</div>
<div *ngIf="!(modeRenduService.enModeImpression$ | async)">
  <footer class="footer mt-auto py-sm-0 text-dark fixed-bottom" [ngClass]="(!enProd) ? 'dev':'prod'">
    <div class="container-sm">
      <div class="float-sm-left">
        <span><b>MJ / SG / SSER</b></span>
      </div>
      <div class="float-sm-right">
        <span *ngIf="ROLES.isHabilite(['gestionnaire'])">
          <a title="Créer un ticket sur le board SDI"
            href="https://gitlab.codeo.intranet.justice.gouv.fr/sser/bis/sdi/suivi-des-travaux/boards?scope=all&utf8=%E2%9C%93&state=opened&label_name[]=D%3AAAV" target="_blank">
            <i class="material-icons md-18 align-bottom">feedback</i>
          </a>
        </span>
        |
        <span class="badge badge-pill">
          <li class="nav-item mx-1 px-1 my-1">
          <a class="nav-link" routerLinkActive="active" class="text-dark" routerLink="/accessibilite" title="Déclaration d'Accessibilité">
            <b>Accessibilité : non conforme</b></a></li>
        </span>
        |
        <span class="badge badge-pill">
          <li class="nav-item mx-1 px-1 my-1"><a href="#" data-toggle="modal" class="text-dark"
              title="Politique de protection des données" data-target="#dpModal"><b>Données Personnelles</b></a></li>
        </span>
        |&nbsp;&nbsp;<span class="badge badge-pill badge-light">Aav {{ this.getVersion() }}</span>
        |&nbsp;&nbsp;<span class="badge badge-pill" [ngClass]="enProd ? 'badge-info':'badge-dark'">{{ enProd ?
          'PRODUCTION':'RECETTE'}}</span>
      </div>
    </div>
  </footer>
</div>

<!-- Modal Donnees personnelles -->
<div class="modal fade" id="dpModal" role="dialog" aria-labelledby="dpModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="dpModalTitle"><I>Données Personnelles</I></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <h4 class="text-center"><B>Politique de protection des données</B></h4><br><br>
        <p> <B>Le SSER </B>traite les données recueillies pour <B>élaborer des statistiques annuelles et des séries
            longues
            sur diverses activités</B>. Les données personnelles ont pour finalité la communication
          entre le SSER et les juridictions sur la collecte, le suivi et la qualité du questionnaire.
          <br><br>
          Les informations à caractère personnel recueillies dans le questionnaire sont stockées sur le serveur sécurisé
          du <B>SSER</B>.
          La base légale du traitement est l’article 6 du RGPD, car il est nécessaire à l’exécution d’une mission
          d’intérêt public ou relevant de l’exercice de l’autorité publique dont est investi le responsable du
          traitement.
          <br><br>
          La fourniture des données personnelles permet une meilleure communication avec la juridiction, mais ne revêt
          pas de caractère obligatoire.
          <br><br>
          Les données personnelles collectées seront communiquées aux seuls destinataires suivants : agents SSER en
          charge de la collecte, de la saisie et de la qualité des questionnaires.
          <br><br>
          Les données à caractère personnel sont conservées pendant 3 ans (coordonnées non génériques du contact des
          juridictions).
          <br><br>
          Vous pouvez accéder aux données vous concernant, les rectifier, demander leur effacement ou exercer votre
          droit à la limitation du traitement de vos données.
          <br><br>
          Consultez le site
          <a href="https://www.cnil.fr/" target="_blank">cnil.fr</a> pour plus d’informations sur vos droits.
          <br><br>
          Pour exercer ces droits ou pour toute question sur le traitement de vos données dans ce dispositif, vous
          pouvez contacter soit le SSER : <a
            href="mailto:enquetes-electroniques.ssmjustice@justice.gouv.fr?Subject=Enquête%20Aav">enquetes-electroniques.ssmjustice&#64;justice.gouv.fr</a>,
          soit notre délégué à la protection des données : <a href="mailto:dpd@justice.gouv.fr">dpd&#64;justice.gouv.fr</a>.
          <br><br>
          Si vous estimez, après nous avoir contactés, que vos droits « Informatique et Libertés » ne sont pas
          respectés, vous pouvez <a href="https://www.cnil.fr/fr/webform/adresser-une-plainte" target="_blank">adresser
            une réclamation à la CNIL</a>.
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fermer</button>
      </div>
    </div>
  </div>
</div>